import { Text } from "native-base";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";

const CommonHeading = ({
  text = "",
  color = COLORS.PARTNERS_HEADING_COLOR,
  fontSize = COMMONFONTSIZE.HEADER_TEXT_FONT_SIZE,
  fontWeight = COMMONFONTWEIGHT.LARGE_FONT_WEIGHT,
}) => {
  return (
    <Text color={color} fontSize={fontSize} fontWeight={fontWeight}>
      {text}
    </Text>
  );
};

export default CommonHeading;
